document.documentElement.classList.add('js-reveal-ready');
if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
  var orObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('or-visible');
        orObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.or-reveal').forEach(function (el) { orObs.observe(el); });
} else {
  document.querySelectorAll('.or-reveal').forEach(function (el) { el.classList.add('or-visible'); });
}
